import { tokenizeTelegramHtml, type FormatTag } from "@/lib/forwarding";
import { cn } from "@/lib/utils";

const TAG_CLASS: Readonly<Record<FormatTag, string>> = {
  b: "font-semibold",
  i: "italic",
  s: "line-through",
  u: "underline",
};

interface MessagePreviewProps {
  /** HTML gerado por renderTemplate(..., "telegram"). */
  readonly html: string;
  readonly platform: "telegram" | "whatsapp";
}

/** Balao de mensagem com a formatacao real (sem innerHTML). No WhatsApp o
 *  sublinhado nao existe e aparece como texto comum. */
export function MessagePreview({ html, platform }: MessagePreviewProps): JSX.Element {
  const segments = tokenizeTelegramHtml(html);
  return (
    <div
      className={cn(
        "max-w-sm whitespace-pre-wrap break-words rounded-2xl rounded-tl-sm px-3.5 py-2.5 text-sm leading-relaxed shadow-sm",
        platform === "whatsapp"
          ? "bg-[#005c4b] text-white"
          : "bg-[hsl(var(--surface-raised))] text-foreground border border-border",
      )}
      data-testid={`preview-${platform}`}
    >
      {segments.length === 0 && <span className="text-muted-foreground">Mensagem vazia</span>}
      {segments.map((segment, index) => (
        <span
          key={index}
          className={cn(
            segment.tags
              .filter((tag) => platform === "telegram" || tag !== "u")
              .map((tag) => TAG_CLASS[tag])
              .join(" "),
          )}
        >
          {segment.text}
        </span>
      ))}
    </div>
  );
}
